import React from "react";
import { HiOutlineChatBubbleLeftRight } from "react-icons/hi2";

function NoMessagesComponent() {
  return (
    <div className="flex h-full mt-10 flex-col items-center justify-center px-6 text-center">
      <div className="flex h-20 w-20 items-center justify-center rounded-full border border-white/10 bg-white/5">
        <HiOutlineChatBubbleLeftRight size={36} className="text-white/40" />
      </div>
      <p className="mt-5 text-lg font-semibold text-white/80">No messages yet</p>
      <p className="mt-1 max-w-[220px] text-sm leading-relaxed text-white/40">
        Start the conversation — your messages will appear here.
      </p>
    </div>
  );
}

export default NoMessagesComponent;